module.exports = __webpack_public_path__ + "static/media/figure-main-background.517667c6.svg";